import { UseMutateAsyncFunction } from '@tanstack/react-query';
import mixpanel from 'mixpanel-browser';

import { File } from 'hooks/data/files/types';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';

export const downloadFileFroms3 = async (
  file_uuid: File['uuid'],
  handleDownload: UseMutateAsyncFunction<void, unknown, string, unknown>
) => {
  mixpanel.track(MIXPANEL_EVENTS.DOWNLOAD_FILE, { file_uuid });
  await handleDownload(`/files/${file_uuid}`);
};
